import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

export function useAccessToken() {
  const { getAccessTokenSilently } = useAuth0();

  const getToken = useCallback(
    () => getAccessTokenSilently(),
    [getAccessTokenSilently]
  );

  return getToken;
}
